export function generateOverheadTableHeader(translate, officeSizes, hasOwnValues) {
  let officeSizeRows = officeSizes.map((officeSize) => ({ headers: "officeSize", name: officeSize.label }));
  let averageHeader = [
    {
      name: "",
      headers: "average",
    },
  ];

  let headerRows = [
    {
      className: "main-header",
      headers: [
        {
          name: translate("benchmarking.evaluations.overheads.table.overheads"),
          id: "overheads",
          className: "bold-header left-align",
          rowSpan: 2,
          colSpan: 1,
        },
        {
          name: "",
          id: "dataQuality",
          className: "",
          rowSpan: 2,
          colSpan: 1,
        },
        {
          name: translate("benchmarking.evaluations.overheads.table.overheads-in-comparison"),
          id: "officeSize",
          className: "bold-header no-border",
          colSpan: officeSizeRows.length,
        },
        {
          name: translate("benchmarking.evaluations.overheads.table.average"),
          id: "average",
          className: "bold-header no-border average",
          colSpan: 1,
        },
      ],
    },
    {
      className: "secondary-header",
      headers: [...officeSizeRows, ...averageHeader],
    },
  ];

  if (hasOwnValues) {
    headerRows[0].headers.push({
      name: translate("benchmarking.evaluations.overheads.table.myOffice"),
      id: "myOffice",
      className: "bold-header no-border",
      colSpan: 2,
    });

    headerRows[1].headers.push(
      {
        name: translate("benchmarking.evaluations.overheads.table.average-percentage"),
        headers: "myOffice",
      },
      {
        name: translate("benchmarking.evaluations.overheads.table.average-delta"),
        headers: "myOffice",
        className: "delta",
      }
    );
  }

  return headerRows;
}

export function getActiveOrAllOfficeSizeItems(filters) {
  let officeSizeFilterIndex = filters.findIndex((e) => e.id === "officeSize");
  let officeSizeItems = filters[officeSizeFilterIndex].items.filter((item) => item.active);
  if (officeSizeItems.length === 0) {
    officeSizeItems = filters[officeSizeFilterIndex].items;
  }
  return officeSizeItems;
}

export function getActiveRefId(filters) {
  let refFilterIndex = filters.findIndex((e) => e.id === "reference");
  let activeItem = filters[refFilterIndex].value;
  let refIndex = activeItem.id;
  refIndex = refIndex - 1;
  return refIndex;
}

export function sortGroupsAlphabetically(a, b) {
  return a.group.localeCompare(b.group);
}

export function sortSubgroups(a) {
  return a.subgroup === "average" ? -1 : 1;
}
